module.exports = __webpack_public_path__ + "img/9.b8cab216.svg";